export { default } from '@esentai/core/features/giftCertificates/api';
